const REST_URL_PARAMS: string[] = [
  'flags', // Contentful preview
  'obj',
  'op', // GraphQL operation name appended to GraphQL requests
  'gtm_debug', // to test GTM tags with tag assistant
  'index', // Remix param
  '_data', // Remix param
]
export const MARKETING_URL_PARAMS: string[] = [
  'adgroupid', // AdWords
  'cve', // Campaign variable existing
  'cvn', // Campaign variable new
  'dclid', // DV350 channel
  'device', // AdWords
  'fbclid', // Facebook click ID
  'gclid', // AdWords (Google click ID)
  'gh_jid', // Greenhouse
  'gh_src', // Greenhouse
  'irgwc', // Impact Radius affiliate links
  'irclickid', // Impact Radius affiliate links
  'keyword', // AdWords
  'loc_physical_ms', // AdWords
  'matchtype', // AdWords
  'rc', // Redemption code, friend referral
  's_id', // General session ID
  'sid', // General session ID
  'term', // AdWords
  'tt_test_id', // Tiktok event testing id
  'ttclid', // Tiktok
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_term',
  'targetid', // Google Ads
  'pst', // Custom position param for more detailed channel tracking
  'domainUserId', // Snowplow ID
  'ch', // LP tracking name
  'pr', // Product preference
]

export const URL_PARAMS: string[] = [
  ...REST_URL_PARAMS,
  ...MARKETING_URL_PARAMS,
]
